<template>
    <validation-observer ref="observer" slim>
        <b-modal v-model="visible"
                 :title="title"
                 cancel-title="ANNULLA"
                 cancel-variant="light"
                 centered
                 modal-class="modal-primary vehicle-form-modal"
                 no-close-on-backdrop
                 ok-title="CONFERMA"
                 scrollable
                 size="lg"
                 @ok="confirm">

            <base-fieldset class="mb-3">

                <float-input v-model="vehicle.targa"
                             :rules="{required: true, cvt_targa: true}"
                             :uppercase="true"
                             label="Targa"
                             name="vehicle.targa"/>

                <div class="form-row">
                    <div class="col-md-6">
                        <float-input v-model="vehicle.marca"
                                     :rules="{required: true}"
                                     label="Marca"
                                     name="vehicle.marca"/>
                    </div>
                    <div class="col-md-6">
                        <float-input v-model="vehicle.modello"
                                     label="Modello"
                                     name="vehicle.modello"/>
                    </div>
                </div>

                <div class="form-row">
                    <div class="col-md-4">
                        <float-input v-model="vehicle.anno_immatricolazione"
                                     :rules="{required: true, integer: true, min_value: 1950, max_value: maxAnno}"
                                     label="Anno immatricolazione"
                                     name="vehicle.anno_immatricolazione"
                                     type="number"/>
                    </div>
                    <div class="col-md-4">
                        <float-input v-model="vehicle.valore_assicurato"
                                     :rules="{required: true, min_value: 0.01}"
                                     label="Valore assicurato (€)"
                                     name="vehicle.valore_assicurato"
                                     step="0.01"
                                     type="number"/>
                    </div>
                    <div class="col-md-4">
                        <float-input v-model="vehicle.km_percorsi"
                                     :rules="{required: true, integer: true, min_value: 0}"
                                     label="Km percorsi"
                                     name="vehicle.km_percorsi"
                                     type="number"/>
                    </div>
                </div>


                <float-select v-model="vehicle.ricovero_notturno"
                              :options="ricoveroOptions"
                              :rules="{required: true}"
                              :searchable="false"
                              label="Ricovero notturno"
                              name="vehicle.ricovero_notturno"/>

                <float-input v-if="vehicle.ricovero_notturno === 'altro'"
                             v-model="vehicle.ricovero_notturno_altro"
                             :rules="{required: true}"
                             label="Specificare altro ricovero"
                             name="vehicle.ricovero_notturno_altro"/>

                <radio-yes-no v-model="vehicle.satellitare"
                              label="Satellitare presente"
                              name="vehicle.satellitare"/>

                <template v-if="vehicle.satellitare === true">
                    <float-input v-model="vehicle.satellitare_marca_modello"
                                 :rules="{required: true}"
                                 label="Satellitare marca/modello"
                                 name="vehicle.satellitare_marca_modello"/>

                    <float-input v-model="vehicle.satellitare_centrale_operativa"
                                 :rules="{required: true}"
                                 label="Centrale operativa"
                                 name="vehicle.satellitare_centrale_operativa"/>
                </template>

                <radio-yes-no v-model="vehicle.leasing"
                              label="Leasing attivo"
                              name="vehicle.leasing"/>

                <template v-if="vehicle.leasing === true">
                    <float-input v-model="vehicle.leasing_societa"
                                 :rules="{required: true}"
                                 label="Società di leasing"
                                 name="vehicle.leasing_societa"/>

                    <float-date v-model="vehicle.leasing_scadenza"
                                :rules="{required: true}"
                                format="ISO"
                                label="Scadenza leasing"
                                name="vehicle.leasing_scadenza"/>
                </template>


                <radio-yes-no v-model="vehicle.sinistri_ultimi_tre_anni"
                              label="Sinistri negli ultimi 3 anni"
                              name="vehicle.sinistri_ultimi_tre_anni"/>

                <float-input v-if="vehicle.sinistri_ultimi_tre_anni === true"
                             v-model="vehicle.sinistri_dettagli"
                             :rules="{required: true}"
                             label="Dettagli sinistri"
                             name="vehicle.sinistri_dettagli"/>

                <radio-yes-no v-model="vehicle.veicolo_gia_assicurato"
                              label="Veicolo già assicurato"
                              name="vehicle.veicolo_gia_assicurato"/>

                <radio-yes-no v-model="vehicle.patente_ritirata"
                              label="Patente ritirata al conducente"
                              name="vehicle.patente_ritirata"/>
            </base-fieldset>

            <base-fieldset>
                <legend>Garanzie</legend>
                <div class="vehicle-form-modal__covers">
                    <b-form-checkbox v-for="cover in availableCovers"
                                     :key="cover.codice"
                                     :checked="isCoverSelected(cover)"
                                     :disabled="cover.mandatory"
                                     @change="toggleCover(cover.codice)">
                        {{ cover.codice }} — {{ cover.descrizione }}
                        <span v-if="cover.mandatory" class="text-muted">(obbligatoria)</span>
                    </b-form-checkbox>
                </div>
            </base-fieldset>
        </b-modal>
    </validation-observer>
</template>

<script>
function emptyVehicle() {
    return {
        targa: null,
        marca: null,
        modello: null,
        anno_immatricolazione: null,
        valore_assicurato: null,
        km_percorsi: null,
        ricovero_notturno: null,
        ricovero_notturno_altro: null,
        satellitare: false,
        satellitare_marca_modello: null,
        satellitare_centrale_operativa: null,
        leasing: false,
        leasing_societa: null,
        leasing_scadenza: null,
        sinistri_ultimi_tre_anni: false,
        sinistri_dettagli: null,
        veicolo_gia_assicurato: false,
        patente_ritirata: false,
        covers: [],
    }
}

export default {
    name: 'VehicleFormModal',
    props: {
        availableCovers: {
            type: Array,
            default: () => [],
        },
        ricoveroOptions: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            visible: false,
            index: null,
            vehicle: emptyVehicle(),
        }
    },
    computed: {
        title() {
            return this.index === null ? 'Aggiungi veicolo' : 'Modifica veicolo'
        },
        //the tariff (init metadata / bound snapshot) decides which covers are mandatory
        mandatoryCovers() {
            return this.availableCovers.filter(cover => cover.mandatory).map(cover => cover.codice)
        },
        maxAnno() {
            return new Date().getFullYear() + 1
        },
    },
    methods: {
        open(vehicle = null, index = null) {
            this.index = index
            this.vehicle = vehicle
                ? {...emptyVehicle(), ...JSON.parse(JSON.stringify(vehicle))}
                : emptyVehicle()
            if (!Array.isArray(this.vehicle.covers)) {
                this.vehicle.covers = []
            }
            this.vehicle.covers = [...new Set([...this.mandatoryCovers, ...this.vehicle.covers])]
            this.visible = true
            this.$nextTick(() => {
                if (this.$refs.observer) this.$refs.observer.reset()
            })
        },
        isCoverSelected(cover) {
            return cover.mandatory || this.vehicle.covers.includes(cover.codice)
        },
        toggleCover(codice) {
            this.vehicle.covers = this.vehicle.covers.includes(codice)
                ? this.vehicle.covers.filter(item => item !== codice)
                : [...this.vehicle.covers, codice]
        },
        async confirm(bvModalEvent) {
            bvModalEvent.preventDefault()
            if (await this.$refs.observer.validate() !== true) return

            this.$emit('save', {vehicle: this.normalize(), index: this.index})
            this.visible = false
        },
        normalize() {
            const vehicle = {...this.vehicle}

            vehicle.targa = (vehicle.targa || '').trim().toUpperCase()
            vehicle.valore_assicurato = parseFloat(vehicle.valore_assicurato)
            vehicle.anno_immatricolazione = vehicle.anno_immatricolazione ? parseInt(vehicle.anno_immatricolazione, 10) : null
            vehicle.km_percorsi = (vehicle.km_percorsi || vehicle.km_percorsi === 0) ? parseInt(vehicle.km_percorsi, 10) : null

            if (vehicle.ricovero_notturno !== 'altro') vehicle.ricovero_notturno_altro = null
            if (vehicle.satellitare !== true) {
                vehicle.satellitare_marca_modello = null
                vehicle.satellitare_centrale_operativa = null
            }
            if (vehicle.leasing !== true) {
                vehicle.leasing_societa = null
                vehicle.leasing_scadenza = null
            }
            if (vehicle.sinistri_ultimi_tre_anni !== true) vehicle.sinistri_dettagli = null

            //the client locks the tariff's mandatory covers on; the backend persists covers as-is
            //and the tariff snapshot enforces the mandatory ones at issue
            vehicle.covers = [...new Set([...this.mandatoryCovers, ...vehicle.covers])]

            return vehicle
        },
    }
}
</script>

<style lang="scss">

@import "@sass/vue-component";

.vehicle-form-modal {
    legend {
        color: $primary;
        font-size: 1.1rem;
    }

    &__covers {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
        gap: 0.5rem;
    }
}
</style>
